import checkIfBrowser from '../env/is-browser';
export { self, window, global, document, process, console } from '../env/globals';
export var VERSION = typeof __VERSION__ !== 'undefined' ? __VERSION__ : 'untranspiled source';
export var isBrowser = checkIfBrowser();
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/esm/utils/globals.js
// module id = 190
// module chunks = 0